// import React, { useState, useEffect, useRef } from 'react';
// import logo from './assets/mqoelogo.png';
// import { Link } from 'react-router-dom';
// const AnimatedCounter = ({ end, duration = 2000 }) => {
//     const [count, setCount] = useState(0);
//     const countRef = useRef(null);
//     const [isVisible, setIsVisible] = useState(false);

//     useEffect(() => {
//         const observer = new IntersectionObserver(
//             ([entry]) => {
//                 if (entry.isIntersecting) {
//                     setIsVisible(true);
//                 }
//             },
//             { threshold: 0.1 }
//         );

//         if (countRef.current) {
//             observer.observe(countRef.current);
//         }

//         return () => observer.disconnect();
//     }, []);

//     useEffect(() => {
//         if (!isVisible) return;

//         let start = 0;
//         const increment = end / (duration / 16);
//         const timer = setInterval(() => {
//             start += increment;
//             if (start >= end) {
//                 setCount(end);
//                 clearInterval(timer);
//             } else {
//                 setCount(Math.floor(start));
//             }
//         }, 16);

//         return () => clearInterval(timer);
//     }, [isVisible, end, duration]);

//     return <span ref={countRef}>{count.toLocaleString()}</span>;
// };

// // Main App Component
// const QHome = () => {
//     const [isMenuOpen, setIsMenuOpen] = useState(false);
//     const [isServicesOpen, setIsServicesOpen] = useState(false);
//     const [formSubmitted, setFormSubmitted] = useState(false);
//     const [userName, setUserName] = useState('');

//     useEffect(() => {
//         const link = document.createElement('link');
//         link.rel = 'stylesheet';
//         link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
//         document.head.appendChild(link);
//     }, []);

//     const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         const name = e.target.elements.name.value;
//         setUserName(name);
//         setFormSubmitted(true);
//     };

//     const serviceOptions = [
//         { name: "Noorani Qaida", link: "/" }, // Home ya specific route
//         { name: "Tajweed-e-Quran", link: "/tajweed" }, // Yeh aapka naya route
//         { name: "Basic Islamic Educations", link: "/" }
//     ];

//     return (
//         <div className="font-['Inter'] text-[#1a3a2a] bg-white pt-20 overflow-x-hidden scroll-smooth">
//             {/* CSS Styles injected via Template Literal to maintain exactness */}
//             <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&display=swap');
//         
//         :root {
//             --primary-green: #147a44;
//             --submit-brown: #634d3a;
//             --accent-lime: #a6ff00;
//         }

//         body {
//             font-family: 'Inter', sans-serif;
//         }

//         .nav-link {
//             font-weight: 600;
//             color: #1a3a2a;
//             transition: color 0.3s;
//             display: flex;
//             align-items: center;
//             gap: 4px;
//             cursor: pointer;
//         }

//         .nav-link:hover {
//             color: var(--primary-green);
//         }

//         .dropdown-menu {
//             position: absolute;
//             top: 100%;
//             left: 0;
//             background: white;
//             min-width: 220px;
//             box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//             border-radius: 8px;
//             padding: 10px 0;
//             opacity: 0;
//             visibility: hidden;
//             transform: translateY(10px);
//             transition: all 0.3s ease;
//             border-top: 3px solid var(--primary-green);
//         }

//         .group:hover .dropdown-menu {
//             opacity: 1;
//             visibility: visible;
//             transform: translateY(0);
//         }

//         .dropdown-item {
//             padding: 10px 20px;
//             display: block;
//             color: #1a3a2a;
//             font-weight: 500;
//             transition: all 0.2s;
//         }

//         .dropdown-item:hover {
//             background-color: #f4fbf7;
//             color: var(--primary-green);
//             padding-left: 25px;
//         }

//         .green-pill {
//             background-color: #e9f5ee;
//             color: var(--primary-green);
//             padding: 8px 16px;
//             border-radius: 25px;
//             font-size: 14px;
//             font-weight: 600;
//             display: flex;
//             align-items: center;
//             gap: 8px;
//         }

//         .course-card {
//             background: white;
//             border-radius: 20px;
//             padding: 40px 30px;
//             text-align: center;
//             box-shadow: 0 10px 30px rgba(0,0,0,0.05);
//             transition: transform 0.3s ease;
//             height: 100%;
//             display: flex;
//             flex-direction: column;
//             justify-content: space-between;
//         }

//         .course-card:hover {
//             transform: translateY(-10px);
//         }

//         .stat-card {
//             background: rgba(255, 255, 255, 0.1);
//             backdrop-filter: blur(12px);
//             padding: 40px 20px;
//             border-radius: 24px;
//             text-align: center;
//             color: white;
//             border: 1px solid rgba(255, 255, 255, 0.2);
//             transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//             position: relative;
//             overflow: hidden;
//             box-shadow: 0 15px 35px rgba(0,0,0,0.2);
//             transform-style: preserve-3d;
//             perspective: 1000px;
//         }

//         .stat-card:hover {
//             transform: translateY(-10px) rotateX(5deg) rotateY(5deg);
//             border-color: var(--accent-lime);
//             box-shadow: 0 25px 50px rgba(0,0,0,0.3), 0 0 20px rgba(166, 255, 0, 0.2);
//         }

//         .stat-card::before {
//             content: '';
//             position: absolute;
//             top: -50%;
//             left: -50%;
//             width: 200%;
//             height: 200%;
//             background: radial-gradient(circle, rgba(166, 255, 0, 0.1) 0%, transparent 70%);
//             opacity: 0;
//             transition: opacity 0.3s;
//         }

//         .stat-card:hover::before {
//             opacity: 1;
//         }

//         .form-input {
//             width: 100%;
//             border: 1px solid #ced4da;
//             padding: 15px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//             outline: none;
//             transition: border-color 0.3s;
//         }

//         .form-input:focus {
//             border-color: var(--primary-green);
//         }

//         .btn-submit {
//             background-color: var(--submit-brown);
//             color: white;
//             width: 100%;
//             padding: 15px;
//             border-radius: 4px;
//             font-weight: 700;
//             text-transform: capitalize;
//             font-size: 18px;
//             transition: opacity 0.3s;
//             cursor: pointer;
//         }

//         .btn-submit:hover {
//             opacity: 0.9;
//         }

//         .whatsapp-float {
//             position: fixed;
//             bottom: 30px;
//             right: 30px;
//             background-color: #25d366;
//             color: white;
//             width: 60px;
//             height: 60px;
//             border-radius: 50%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             font-size: 30px;
//             box-shadow: 2px 5px 15px rgba(0,0,0,0.3);
//             z-index: 1000;
//             transition: transform 0.3s;
//         }

//         .whatsapp-float:hover {
//             transform: scale(1.1);
//         }

//         .stats-bg-glow {
//             position: absolute;
//             width: 300px;
//             height: 300px;
//             background: var(--accent-lime);
//             filter: blur(150px);
//             opacity: 0.15;
//             border-radius: 50%;
//             pointer-events: none;
//         }
//       `}</style>

//             {/* WhatsApp Button */}
//             <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer" className="whatsapp-float">
//                 <i className="fab fa-whatsapp"></i>
//             </a>

//             {/* Header */}
//             <header className="py-4 px-6 lg:px-24 bg-white fixed top-0 left-0 right-0 z-[1000] shadow-md">
//                 <div className="max-w-7xl mx-auto flex justify-between items-center">
//                     <div className="flex items-center gap-3">
//                         {/* Logo Section */}
//                         <div className="flex items-center">
//                             <img
//                                 src={logo}
//                                 alt="Madina Quran Online Education"
//                                 className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
//                             />
//                         </div>

//                         {/* Brand Name */}
//                         <span className="text-xl font-extrabold text-[#147a44] hidden lg:block">
//                             Madina Quran Online Education
//                         </span>
//                     </div>

//                     <nav className="hidden md:flex gap-10">
//                         <a href="#" className="nav-link">Home</a>

//                         {/* Desktop Dropdown */}
//                         <div className="relative group">
//                             <div className="nav-link cursor-pointer">
//                                 Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
//                             </div>
//                             <div className="dropdown-menu">
//                                 {serviceOptions.map((option, idx) => (
//                                     <a key={idx} href={option.link} className="dropdown-item">{option.name}</a>
//                                 ))}
//                             </div>
//                         </div>

//                         <a href="#contact" className="nav-link">Contact Us</a>
//                     </nav>

//                     <div className="md:hidden text-2xl cursor-pointer" onClick={toggleMenu}>
//                         <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
//                     </div>
//                 </div>
//             </header>

//             {/* Mobile Nav */}
//             {isMenuOpen && (
//                 <div className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-xl z-[999] border-t max-h-[80vh] overflow-y-auto">
//                     <a href="#" className="nav-link py-2 border-b" onClick={toggleMenu}>Home</a>

//                     {/* Mobile Dropdown Toggle */}
//                     <div className="border-b">
//                         <div className="nav-link py-2 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
//                             Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
//                         </div>
//                         {isServicesOpen && (
//                             <div className="pl-4 pb-2 bg-gray-50 flex flex-col">
//                                 {serviceOptions.map((option, idx) => (
//                                     <Link
//                                         key={idx}
//                                         to={option.link}
//                                         className="py-2 text-sm font-medium text-gray-600"
//                                         onClick={toggleMenu}
//                                     >
//                                         {option.name}
//                                     </Link>
//                                 ))}
//                             </div>
//                         )}
//                     </div>

//                     <a href="#contact" className="nav-link py-2" onClick={toggleMenu}>Contact Us</a>
//                 </div>
//             )}

//             {/* Hero Section */}
//             <section className="bg-[#f4fbf7] py-16 px-6 lg:px-24">
//                 <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
//                     <div>
//                         <h1 className="text-4xl lg:text-6xl font-extrabold text-[#147a44] leading-tight mb-6">
//                             Online Quran Teaching With Expert Tutors
//                         </h1>
//                         <p className="text-lg text-gray-700 mb-8 leading-relaxed">
//                             Madina Quran Online Education offers professional online Quran teaching for kids and adults worldwide. Learn the Holy Quran with Tajweed through one-to-one live classes with qualified male and female teachers.
//                         </p>
//                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
//                             <div className="green-pill"><i className="fas fa-check-circle"></i> One-to-One Quran Classes</div>
//                             <div className="green-pill"><i className="fas fa-check-circle"></i> Certified Male & Female Tutors</div>
//                             <div className="green-pill"><i className="fas fa-check-circle"></i> Flexible Class Timings</div>
//                         </div>
//                         <a href="#contact" className="inline-block bg-[#147a44] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#0d5e34] transition shadow-lg">Get Started Now</a>
//                     </div>
//                     <div className="relative">
//                         <img src="https://images.unsplash.com/photo-1585036156171-384164a8c675" alt="Holy Quran" className="rounded-3xl shadow-2xl w-full object-cover" />
//                     </div>
//                 </div>
//             </section>

//             {/* Stats Section with Animations and Glow */}
//             <section className="bg-[#147a44] py-24 px-6 relative overflow-hidden">
//                 {/* Background Glowing Effects */}
//                 <div className="stats-bg-glow -top-20 -left-20"></div>
//                 <div className="stats-bg-glow -bottom-20 -right-20"></div>

//                 <div className="max-w-7xl mx-auto text-center mb-16 relative z-10">
//                     <h2 className="text-4xl font-bold text-white mb-4">Trusted Online Quran Teaching Academy Worldwide</h2>
//                     <p className="text-green-100 opacity-90 text-lg">Thousands of students trust our academy for professional Quran learning.</p>
//                 </div>

//                 <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
//                     <div className="stat-card">
//                         <div className="text-5xl font-black text-[#a6ff00] mb-3">
//                             <AnimatedCounter end={5000} />+
//                         </div>
//                         <div className="text-sm font-bold uppercase tracking-[2px]">Students</div>
//                     </div>

//                     <div className="stat-card">
//                         <div className="text-5xl font-black text-[#a6ff00] mb-3">
//                             <AnimatedCounter end={20} />+
//                         </div>
//                         <div className="text-sm font-bold uppercase tracking-[2px]">Countries</div>
//                     </div>

//                     <div className="stat-card">
//                         <div className="text-5xl font-black text-[#a6ff00] mb-3">
//                             <AnimatedCounter end={100} />+
//                         </div>
//                         <div className="text-sm font-bold uppercase tracking-[2px]">Expert Tutors</div>
//                     </div>

//                     <div className="stat-card">
//                         <div className="text-5xl font-black text-[#a6ff00] mb-3">
//                             <AnimatedCounter end={10} />
//                         </div>
//                         <div className="text-sm font-bold uppercase tracking-[2px]">Years Experience</div>
//                     </div>
//                 </div>
//             </section>

//             {/* Services Section */}
//             <section id="services" className="bg-[#f4fbf7] py-20 px-6">
//                 <div className="max-w-7xl mx-auto text-center mb-16">
//                     <h2 className="text-4xl font-bold mb-4 text-[#147a44]">Our Online Quran Courses</h2>
//                     <p className="text-gray-600 max-w-3xl mx-auto">At Madina Quran Online Education, we offer specialized courses for kids and adults designed to make learning easy and effective.</p>
//                 </div>
//                 <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
//                     <div className="course-card">
//                         <div>
//                             <div className="text-5xl mb-6">📖</div>
//                             <h3 className="text-xl font-bold text-[#147a44] mb-4">Noorani Qaida Course</h3>
//                             <p className="text-gray-600 mb-8">Basic Quran reading skills and Arabic letter pronunciation for beginners. Ideal for kids starting their journey.</p>
//                         </div>
//                         <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//                     </div>
//                     <div className="course-card">
//                         <div>
//                             <div className="text-5xl mb-6">🕌</div>
//                             <h3 className="text-xl font-bold text-[#147a44] mb-4">Quran with Tajweed</h3>
//                             <p className="text-gray-600 mb-8">Learn to recite the Holy Quran correctly with proper Tajweed rules and beautiful pronunciation.</p>
//                         </div>
//                         <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//                     </div>
//                     <div className="course-card">
//                         <div>
//                             <div className="text-5xl mb-6">⭐</div>
//                             <h3 className="text-xl font-bold text-[#147a44] mb-4">Islamic Education</h3>
//                             <p className="text-gray-600 mb-8">Strengthen your spiritual foundation through our comprehensive Islamic studies and Hifz program, featuring expert guidance and personalized daily tracking.</p>
//                         </div>
//                         <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//                     </div>
//                 </div>
//             </section>

//             {/* Contact Form Section */}
//             <section id="contact" className="py-20 px-6 bg-white">
//                 <div className="max-w-3xl mx-auto text-center mb-10">
//                     <h2 className="text-3xl font-bold text-[#147a44]">Contact Us / Register</h2>
//                     <p className="text-gray-500 mt-2">Fill the form below and we'll get back to you shortly to schedule your trial class.</p>
//                 </div>
//                 <div className="max-w-xl mx-auto">
//                     {!formSubmitted ? (
//                         <form className="space-y-4" onSubmit={handleSubmit}>
//                             <input type="text" name="name" className="form-input" placeholder="Your Name" required />
//                             <input type="tel" name="phone" className="form-input" placeholder="Phone (e.g. +1...)" required />
//                             <input type="email" name="email" className="form-input" placeholder="Email Address" required />
//                             <textarea name="message" className="form-input h-32" placeholder="Your Message or Chosen Course"></textarea>
//                             <button type="submit" className="btn-submit">SUBMIT APPLICATION</button>
//                         </form>
//                     ) : (
//                         <div className="text-center p-10 bg-green-50 rounded-lg">
//                             <i className="fas fa-check-circle text-5xl text-[#147a44] mb-4"></i>
//                             <h3 className="text-2xl font-bold text-[#147a44] mb-2">Thank You, {userName}!</h3>
//                             <p className="text-gray-600">Your application has been received. Our team will contact you within 24 hours.</p>
//                             <button onClick={() => setFormSubmitted(false)} className="mt-4 text-[#147a44] underline font-bold">Send another message</button>
//                         </div>
//                     )}
//                 </div>
//             </section>

//             {/* Footer */}
//             <footer className="bg-gray-50 border-t border-gray-100 py-12 px-6">
//                 <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 mb-8 text-left">
//                     <div>
//                         <div className="flex items-center gap-2 mb-4">
//                             <div className="w-8 h-8 bg-[#147a44] rounded-full flex items-center justify-center text-white font-bold text-xs">MQOE</div>
//                             <span className="text-lg font-extrabold text-[#147a44]">Madina Quran Online Education</span>
//                         </div>
//                         <p className="text-gray-500 text-sm">Professional Online Quran Academy providing quality education worldwide for over a decade.</p>
//                     </div>
//                     <div>
//                         <h4 className="font-bold text-[#147a44] mb-4">Quick Links</h4>
//                         <ul className="text-gray-500 text-sm space-y-2">
//                             <li><a href="#" className="hover:text-[#147a44]">Home</a></li>
//                             <li><a href="#services" className="hover:text-[#147a44]">Services</a></li>
//                             <li><a href="#contact" className="hover:text-[#147a44]">Register Now</a></li>
//                         </ul>
//                     </div>
//                     <div>
//                         <h4 className="font-bold text-[#147a44] mb-4">Support</h4>
//                         <ul className="text-gray-500 text-sm space-y-2">
//                             <li><i className="fas fa-envelope mr-2"></i> madinaquranonlineeducation@gmail.com</li>
//                             <li><i className="fas fa-phone mr-2"></i> +92 315 5141289</li>
//                         </ul>
//                     </div>
//                 </div>
//                 <div className="border-t border-gray-200 pt-8 text-center text-gray-400 text-xs">
//                     <p>&copy; 2024 Madina Quran Online Education. All Rights Reserved.</p>
//                 </div>
//             </footer>
//         </div>
//     );
// };

// export default QHome;




import React, { useState, useEffect,useRef } from 'react';
import logo from './assets/mqoelogo.png';
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from '@emailjs/browser';

const AnimatedCounter = ({ end, duration = 2000 }) => {
  const [count, setCount] = useState(0);
  const countRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
 

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (countRef.current) {
      observer.observe(countRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [isVisible, end, duration]);

  return <span ref={countRef}>{count.toLocaleString()}</span>;
};

// Main App Component
const QHome = () => {
   const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

 const form = useRef(); // Form reference ke liye

  const [userName, setUserName] = useState("");
  const contactRef = useRef(null);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
  if (window.location.hash === "#contact") {
    setTimeout(() => {
      document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  }
}, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleSubmit = (e) => {
    e.preventDefault();
    const name = e.target.elements.name.value;
    setUserName(name);
    setFormSubmitted(true);
  };

  const serviceOptions = [
    { name: "Noorani Qaida", link: "/noorani" },
    { name: "Tajweed-e-Quran", link: "/tajweed" },
    { name: "Basic Islamic Educations", link: "/all" }
  ];

 

  const handleSubmition = (e) => {
  e.preventDefault();

  // Current time nikalne ke liye (agar aap template mein {{time}} use kar rahe hain)
  const currentTime = new Date().toLocaleString();

  // Hum direct form object bhej rahe hain, lekin extra data (time) add karne ke liye
  // Template parameters object banana behtar rehta hai
  const templateParams = {
    name: form.current.name.value,
    email: form.current.email.value,
    phone: form.current.phone.value, // Agar template mein phone add karna ho
    message: form.current.message.value,
    time: currentTime, // Ye {{time}} variable ko fill karega
  };

  emailjs.send(
     'service_inc926r', 
      'template_jkeawro',  
    templateParams, // Form ki jagah params bhej rahe hain
     'WYbjXkOtNhvDDvtgJ'
  )
  .then((result) => {
      setUserName(templateParams.name);
      setFormSubmitted(true);
  }, (error) => {
      alert("Error: " + error.text);
  });
};

  return (
    <div className="font-['Inter'] text-[#1a3a2a] bg-white pt-20 overflow-x-hidden scroll-smooth">
      {/* CSS Styles injected via Template Literal to maintain exactness */}
    <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&display=swap');
        
        :root {
            --primary-green: #147a44;
            --submit-brown: #634d3a;
            --accent-lime: #a6ff00;
        }

        body {
            font-family: 'Inter', sans-serif;
        }

        .nav-link {
            font-weight: 600;
            color: #1a3a2a;
            transition: color 0.3s;
            display: flex;
            align-items: center;
            gap: 4px;
            cursor: pointer;
        }

        .nav-link:hover {
            color: var(--primary-green);
        }

        .dropdown-menu {
            position: absolute;
            top: 100%;
            left: 0;
            background: white;
            min-width: 220px;
            box-shadow: 0 10px 25px rgba(0,0,0,0.1);
            border-radius: 8px;
            padding: 10px 0;
            opacity: 0;
            visibility: hidden;
            transform: translateY(10px);
            transition: all 0.3s ease;
            border-top: 3px solid var(--primary-green);
        }

        .group:hover .dropdown-menu {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
        }

        .dropdown-item {
            padding: 10px 20px;
            display: block;
            color: #1a3a2a;
            font-weight: 500;
            transition: all 0.2s;
        }

        .dropdown-item:hover {
            background-color: #f4fbf7;
            color: var(--primary-green);
            padding-left: 25px;
        }

        .green-pill {
            background-color: #e9f5ee;
            color: var(--primary-green);
            padding: 8px 16px;
            border-radius: 25px;
            font-size: 14px;
            font-weight: 600;
            display: flex;
            align-items: center;
            gap: 8px;
        }

        .course-card {
            background: white;
            border-radius: 20px;
            padding: 40px 30px;
            text-align: center;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05);
            transition: transform 0.3s ease;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .course-card:hover {
            transform: translateY(-10px);
        }

        .stat-card {
            background: rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(12px);
            padding: 40px 20px;
            border-radius: 24px;
            text-align: center;
            color: white;
            border: 1px solid rgba(255, 255, 255, 0.2);
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            position: relative;
            overflow: hidden;
            box-shadow: 0 15px 35px rgba(0,0,0,0.2);
            transform-style: preserve-3d;
            perspective: 1000px;
        }

        .stat-card:hover {
            transform: translateY(-10px) rotateX(5deg) rotateY(5deg);
            border-color: var(--accent-lime);
            box-shadow: 0 25px 50px rgba(0,0,0,0.3), 0 0 20px rgba(166, 255, 0, 0.2);
        }

        .stat-card::before {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(166, 255, 0, 0.1) 0%, transparent 70%);
            opacity: 0;
            transition: opacity 0.3s;
        }

        .stat-card:hover::before {
            opacity: 1;
        }

        .form-input {
            width: 100%;
            border: 1px solid #ced4da;
            padding: 15px;
            border-radius: 4px;
            margin-bottom: 15px;
            outline: none;
            transition: border-color 0.3s;
        }

        .form-input:focus {
            border-color: var(--primary-green);
        }

        .btn-submit {
            background-color: var(--submit-brown);
            color: white;
            width: 100%;
            padding: 15px;
            border-radius: 4px;
            font-weight: 700;
            text-transform: capitalize;
            font-size: 18px;
            transition: opacity 0.3s;
            cursor: pointer;
        }

        .btn-submit:hover {
            opacity: 0.9;
        }

        .whatsapp-float {
            position: fixed;
            bottom: 30px;
            right: 30px;
            background-color: #25d366;
            color: white;
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            box-shadow: 2px 5px 15px rgba(0,0,0,0.3);
            z-index: 1000;
            transition: transform 0.3s;
        }

        .whatsapp-float:hover {
            transform: scale(1.1);
        }

        .stats-bg-glow {
            position: absolute;
            width: 300px;
            height: 300px;
            background: var(--accent-lime);
            filter: blur(150px);
            opacity: 0.15;
            border-radius: 50%;
            pointer-events: none;
        }
      `}</style>

      {/* WhatsApp Button */}
       <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer" className="whatsapp-float">
        <i className="fab fa-whatsapp"></i>
      </a>

          {/* Header */}
     <header className="py-4 px-6 lg:px-24 bg-white fixed top-0 left-0 right-0 z-[1000] shadow-md">
  <div className="max-w-7xl mx-auto flex justify-between items-center">
    <div className="flex items-center gap-3">
      {/* Logo Section */}
      <div className="flex items-center">
        <img 
          src={logo} 
          alt="Madina Quran Online Education" 
          className="h-16 w-auto object-contain"
        />
      </div>
      
      {/* Brand Name */}
      <span className="text-sm md:text-lg lg:text-xl font-extrabold text-[#147a44]">
        Madina Quran Online Education
      </span>
      {/* Social Media Icons (Desktop) */}
    <div className="hidden md:flex items-center gap-4 ml-6">
      <a href="https://www.facebook.com/people/Jamia-Madina-Tul-Quran-Online-Academy/61581687654772/?rdid=a5sb3u7e1r2ckVRz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1G7EYvJyud%2F" className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-facebook-f"></i>
      </a>
      <a href="#" className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-instagram"></i>
      </a>
      <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer"  className="text-green-600 hover:text-[#147a44] transition text-lg">
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
    </div>
    
    <nav className="hidden md:flex gap-10">
      <a href="#" className="nav-link">Home</a>
      
      {/* Desktop Dropdown */}
      <div className="relative group">
        <div className="nav-link cursor-pointer">
          Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
        </div>
        <div className="dropdown-menu">
          {serviceOptions.map((option, idx) => (
            <a key={idx} href={option.link} className="dropdown-item">{option.name}</a>
          ))}
        </div>
      </div>

      <a href="#contact" className="nav-link">Contact Us</a>
    </nav>

    

    <div className="md:hidden text-2xl cursor-pointer" onClick={toggleMenu}>
      <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
    </div>
  </div>
</header>

      {/* Mobile Nav */}
      {isMenuOpen && (
        <div className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-xl z-[999] border-t max-h-[80vh] overflow-y-auto">
          <a href="#" className="nav-link py-2 border-b" onClick={toggleMenu}>Home</a>
          
          {/* Mobile Dropdown Toggle */}
          <div className="border-b">
            <div className="nav-link py-2 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
              Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
            </div>
            {isServicesOpen && (
              <div className="pl-4 pb-2 bg-gray-50 flex flex-col">
                {serviceOptions.map((option, idx) => (
                  <a key={idx} href={option.link} className="py-2 text-sm font-medium text-gray-600" onClick={toggleMenu}>{option.name}</a>
                ))}
              </div>
            )}
          </div>
          
          <a href="#contact" className="nav-link py-2" onClick={toggleMenu}>Contact Us</a>

          {/* Social Media Icons (Mobile) */}
          <div className="flex gap-4 pt-3">
            <a href="https://www.facebook.com/people/Jamia-Madina-Tul-Quran-Online-Academy/61581687654772/?rdid=a5sb3u7e1r2ckVRz&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1G7EYvJyud%2F"><i className="fab fa-facebook-f text-gray-600"></i></a>
            <a href="#"><i className="fab fa-instagram text-gray-600"></i></a>
            <a href="#"><i className="fab fa-whatsapp text-gray-600"></i></a>
          </div>
        </div>
      )}

      {/* Hero Section */}
      <section className="bg-[#f4fbf7] py-16 px-6 lg:px-24">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl lg:text-6xl font-extrabold text-[#147a44] leading-tight mb-6">
              Online Quran Teaching With Expert Tutors
            </h1>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Madina Quran Online Education offers professional online Quran teaching for kids and adults worldwide. Learn the Holy Quran with Tajweed through one-to-one live classes with qualified male and female teachers.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              <div className="green-pill"><i className="fas fa-check-circle"></i> One-to-One Quran Classes</div>
              <div className="green-pill"><i className="fas fa-check-circle"></i> Certified Male & Female Tutors</div>
              <div className="green-pill"><i className="fas fa-check-circle"></i> Flexible Class Timings</div>
            </div>
            <a href="#contact" className="inline-block bg-[#147a44] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#0d5e34] transition shadow-lg">Get Started Now</a>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1585036156171-384164a8c675" alt="Holy Quran" className="rounded-3xl shadow-2xl w-full object-cover" />
          </div>
        </div>
      </section>

      {/* Stats Section with Animations and Glow */}
      <section className="bg-[#147a44] py-24 px-6 relative overflow-hidden">
        {/* Background Glowing Effects */}
        <div className="stats-bg-glow -top-20 -left-20"></div>
        <div className="stats-bg-glow -bottom-20 -right-20"></div>

        <div className="max-w-7xl mx-auto text-center mb-16 relative z-10">
          <h2 className="text-4xl font-bold text-white mb-4">Trusted Online Quran Teaching Academy Worldwide</h2>
          <p className="text-green-100 opacity-90 text-lg">Thousands of students trust our academy for professional Quran learning.</p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
          <div className="stat-card">
            <div className="text-5xl font-black text-[#a6ff00] mb-3">
              <AnimatedCounter end={5000} />+
            </div>
            <div className="text-sm font-bold uppercase tracking-[2px]">Students</div>
          </div>

          <div className="stat-card">
            <div className="text-5xl font-black text-[#a6ff00] mb-3">
              <AnimatedCounter end={20} />+
            </div>
            <div className="text-sm font-bold uppercase tracking-[2px]">Countries</div>
          </div>

          <div className="stat-card">
            <div className="text-5xl font-black text-[#a6ff00] mb-3">
              <AnimatedCounter end={100} />+
            </div>
            <div className="text-sm font-bold uppercase tracking-[2px]">Expert Tutors</div>
          </div>

          <div className="stat-card">
            <div className="text-5xl font-black text-[#a6ff00] mb-3">
              <AnimatedCounter end={10} />
            </div>
            <div className="text-sm font-bold uppercase tracking-[2px]">Years Experience</div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="bg-[#f4fbf7] py-20 px-6">
        <div className="max-w-7xl mx-auto text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-[#147a44]">Our Online Quran Courses</h2>
          <p className="text-gray-600 max-w-3xl mx-auto">At Madina Quran Online Education, we offer specialized courses for kids and adults designed to make learning easy and effective.</p>
        </div>
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
          <div className="course-card">
            <div>
              <div className="text-5xl mb-6">📖</div>
              <h3 className="text-xl font-bold text-[#147a44] mb-4">Noorani Qaida Course</h3>
              <p className="text-gray-600 mb-8">Basic Quran reading skills and Arabic letter pronunciation for beginners. Ideal for kids starting their journey.</p>
            </div>
            <a href="/all" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
          </div>
          <div className="course-card">
            <div>
              <div className="text-5xl mb-6">🕌</div>
              <h3 className="text-xl font-bold text-[#147a44] mb-4">Quran with Tajweed</h3>
              <p className="text-gray-600 mb-8">Learn to recite the Holy Quran correctly with proper Tajweed rules and beautiful pronunciation.</p>
            </div>
            <a href="/all" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
          </div>
          <div className="course-card">
            <div>
              <div className="text-5xl mb-6">⭐</div>
              <h3 className="text-xl font-bold text-[#147a44] mb-4">Islamic Education</h3>
              <p className="text-gray-600 mb-8">Strengthen your spiritual foundation through our comprehensive Islamic studies and Hifz program, featuring expert guidance and personalized daily tracking.</p>
            </div>
            <a href="/all" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
<section id="contact" className="py-20 px-6 bg-gradient-to-br from-[#e6f4ea] to-white">
      <div className="max-w-3xl mx-auto text-center mb-10">
        <h2 className="text-3xl font-bold text-[#147a44]">Contact Us / Register</h2>
        <p className="text-gray-500 mt-2">
          Fill the form below and we'll get back to you shortly to schedule your trial class.
        </p>  
      </div>

      <div className="max-w-xl mx-auto">
        {!formSubmitted ? (
          <form 
            ref={form} // Ref connect kar di
            className="space-y-5 backdrop-blur-xl bg-white/60 border border-white/30 shadow-2xl rounded-3xl p-8"
            onSubmit={handleSubmition}
          >
            {/* Name */}
            <input 
              type="text" 
              name="name" // Ye name EmailJS template me {{name}} banega
              placeholder="Your Name"
              required
              className="w-full px-5 py-4 rounded-xl bg-white/70 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#28a745] focus:bg-white transition"
            />

            {/* Phone */}
            <input 
              type="tel" 
              name="phone" // {{phone}}
              placeholder="Phone (e.g. +1...)"
              required
              className="w-full px-5 py-4 rounded-xl bg-white/70 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#28a745] focus:bg-white transition"
            />

            {/* Email */}
            <input 
              type="email" 
              name="email" // {{email}}
              placeholder="Email Address"
              required
              className="w-full px-5 py-4 rounded-xl bg-white/70 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#28a745] focus:bg-white transition"
            />

            {/* Message */}
            <textarea 
              name="message" // {{message}}
              placeholder="Your Message or Chosen Course"
              className="w-full px-5 py-4 rounded-xl bg-white/70 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#28a745] focus:bg-white transition h-32 resize-none"
            />

            {/* Button */}
            <div className="flex justify-center">
              <motion.button 
                type="submit"
                whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(40, 167, 69, 0.3)" }}
                whileTap={{ scale: 0.98 }}
                className="w-full md:w-auto text-white px-12 py-5 rounded-2xl font-bold text-[18px] tracking-wide transition-all shadow-xl bg-gradient-to-r from-[#28a745] to-[#147a44]"
              >
                Submit Application
              </motion.button>
            </div>
          </form>
        ) : (
          <div className="text-center p-10 backdrop-blur-xl bg-green-50/70 border border-green-200 rounded-3xl shadow-xl">
            <h3 className="text-2xl font-bold text-[#147a44] mb-2">
              Thank You, {userName}!
            </h3>
            <p className="text-gray-600">
              Your application has been received. Our team will contact you within 24 hours.
            </p>
            <button 
              onClick={() => setFormSubmitted(false)} 
              className="mt-4 text-[#147a44] underline font-bold"
            >
              Send another message
            </button>
          </div>
        )}
      </div>
    </section>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-100 py-12 px-6">
        <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 mb-8 text-left">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#147a44] rounded-full flex items-center justify-center text-white font-bold text-xs">MQOE</div>
              <span className="text-lg font-extrabold text-[#147a44]">Madina Quran Online Education</span>
            </div>
            <p className="text-gray-500 text-sm">Professional Online Quran Academy providing quality education worldwide for over a decade.</p>
          </div>
          <div>
            <h4 className="font-bold text-[#147a44] mb-4">Quick Links</h4>
            <ul className="text-gray-500 text-sm space-y-2">
              <li><a href="#" className="hover:text-[#147a44]">Home</a></li>
              <li><a href="#services" className="hover:text-[#147a44]">Services</a></li>
              <li><a href="#contact" className="hover:text-[#147a44]">Register Now</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-[#147a44] mb-4">Support</h4>
            <ul className="text-gray-500 text-sm space-y-2">
              <li><i className="fas fa-envelope mr-2"></i> madinaquranonlineeducation@gmail.com</li>
              <li><i className="fas fa-phone mr-2"></i> +92 315 5141289</li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-200 pt-8 text-center text-gray-400 text-xs">
          <p>&copy; 2024 Madina Quran Online Education. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default QHome;